import React from 'react';

export default class AwaitingMessageHandler extends React.Component {
    constructor(props) {
        super(props);

        this.defaultWaitTime = 250;
        this.awaitingResponseTimeout = undefined;
    }

    /**
     * Checks against the waiting prop passed through from chat-bot.jsx. If a message
     * has been received from there, then the prop will be reset to false. If that happens,
     * then clear the timeout set later in this function so this won't get called again.
     * 
     * If the chat-bot is waiting for a response, then set a timeout to recursively call
     * this function to allow for a re-evaluation of the prop condition and is the chat is
     * no longer waiting for a response.
     * 
     * @returns Either and empty string is the chat is no longer waiting, or the awaiting messaging and animation.
     */
    renderAwaitingResponseBlock() {
        if (!this.props.isWaiting){
            clearTimeout(this.awaitingResponseTimeout);
            return '';
        }

        this.awaitingResponseTimeout = setTimeout(() => {
            this.renderAwaitingResponseBlock();
        }, this.defaultWaitTime);

        return  <div className='awaiting-response'>
                    <span className='awaiting-response__icon'></span>
                    <span className='awaiting-response__ellipses'><div></div><div></div><div></div></span>
                </div>
    }

    render() {
        return (
            <div className='awaiting-response__wrapper'>
                {this.renderAwaitingResponseBlock()}
            </div>
        )
    }
}